import { Flex, Icon, Text } from "@amzn/storm-ui";
import { checkCircle } from "@amzn/storm-ui-icons";
import pluralize from "pluralize";
import React from "react";

export interface InsightSelectionActionTextProps {
    identifier: string;
    numSelectedSlides: number;
}

export const InsightSelectionActionText: React.FunctionComponent<
    InsightSelectionActionTextProps
> = (props: InsightSelectionActionTextProps) => {
    const { identifier, numSelectedSlides } = props;

    return numSelectedSlides === 0 ? (
        <></>
    ) : (
        <Flex
            data-testid={`insight-selection-action-text-${identifier}`}
            columnGap="xsmall"
        >
            <Text
                style={{ color: "green" }}
            >{`${pluralize("slide", numSelectedSlides, true)} selected `}</Text>
            <Icon type={checkCircle} style={{ color: "green" }} />
        </Flex>
    );
};
